import React from "react";
import { useState, MouseEvent } from "react";
import { Box, Button, Menu, MenuItem } from "@mui/material";
import getOptionTextColor from "../../../../utils/getOptionsColor";
import styles from "../../insights.module.css";
import RefreshIcon from "@mui/icons-material/Refresh";

interface ActionItem {
    label: string;
    value: string;
}

interface ActionMenuProps {
    options: ActionItem[];
    onAction: (value: string, id: string) => void;
    buttonLabel?: string;
    flagCustomColor?: boolean;
    onRefresh: (isEscalation?: boolean) => void;
}

const ActionMenu: React.FC<ActionMenuProps> = ({ options, onAction, buttonLabel = "Actions", flagCustomColor= false, onRefresh }) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const handleOpenMenu = (event: MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseMenu = () => {
        setAnchorEl(null);
    };

    const handleMenuItemClick = (value: string,name: string) => {
        onAction(value, name);
        handleCloseMenu();
    };

    return (
        <>
            <Box onClick={() => onRefresh(true)} className={styles.refreshCtn}>
                    <RefreshIcon className={styles.iconStyles} />
                </Box>
            <Button
                variant="outlined"
                onClick={handleOpenMenu}
                disabled={options.length ===0}
                className={styles.actionMenuBtn}
            >
                {buttonLabel}
            </Button>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleCloseMenu}
            >
                {options.map((option) => (
                    <MenuItem
                        key={option.value}
                        style={{color: flagCustomColor ? getOptionTextColor("escalation", option.value) : 'inherit'}}
                        onClick={() => handleMenuItemClick(option.value,option.label)}>
                        {option.label}
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
};

export default ActionMenu;
